import { applyMiddleware, compose, createStore } from 'redux';

import thunk from '../utils/reduxThunk';
import { isBrowserEnv } from '../utils/env';

import reducers from './reducers';

const composeEnhancers = (isBrowserEnv() && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

export default preloadedState => {
  return createStore(reducers, preloadedState, composeEnhancers(applyMiddleware(thunk)));
};
